import * as Immutable from "immutable";

import { AbstractImmutableValueMessage } from "./abstractImmutableValueMessage";
import { ConfInfo } from "../..";

export class ReadOnlyParamMessage extends AbstractImmutableValueMessage {

  protected readonly CONF_INFOS = "confInfos";

  get confInfos(): Immutable.List<ConfInfo> { return this.getInternalValue<Immutable.List<ConfInfo>>(this.CONF_INFOS); }
  setConfInfos(confInfos: Immutable.List<ConfInfo>): this { return this.setInternalValue(this.CONF_INFOS, confInfos); }

}